import {
    ChartsLoadApiFailureAction,
    ChartsLoadApiRequestAction,
    ChartsLoadApiSuccessAction,
    CHARTS_LOAD_API_FAILURE,
    CHARTS_LOAD_API_REQUEST,
    CHARTS_LOAD_API_SUCCESS,
} from 'mk2/apps/strollers/containers/Charts/Charts.actions';
import { hashStrollerFilter } from 'mk2/apps/strollers/containers/Charts/Charts.selectors';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

type ChartsActions = ChartsLoadApiRequestAction | ChartsLoadApiSuccessAction | ChartsLoadApiFailureAction;

export interface PerFilterState {
    strollersByUserScoreIds: number[];
    strollersByProfileCountIds: number[];
    loadingState: LoadingState;
    errorMessage: string;
}

export const perFilterInitialState: PerFilterState = {
    strollersByProfileCountIds: [],
    strollersByUserScoreIds: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
};

const perFilterReducer: Reducer<PerFilterState, ChartsActions> = (state = perFilterInitialState, action) => {
    switch (action.type) {
        case CHARTS_LOAD_API_REQUEST:
        case CHARTS_LOAD_API_FAILURE:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            };
        case CHARTS_LOAD_API_SUCCESS:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
                strollersByUserScoreIds: action.response.result.strollersByUserScore,
                strollersByProfileCountIds: action.response.result.strollersByProfileCount,
            };
        default:
            return state;
    }
};

export interface State {
    [hash: string]: PerFilterState;
}

export const initialState: State = {};

const reducer: Reducer<State, ChartsActions> = (state = initialState, action) => {
    switch (action.type) {
        case CHARTS_LOAD_API_REQUEST:
        case CHARTS_LOAD_API_SUCCESS:
        case CHARTS_LOAD_API_FAILURE: {
            const hash = hashStrollerFilter(action.filter);
            return {
                ...state,
                [hash]: perFilterReducer(state[hash], action),
            };
        }
        default:
            return state;
    }
};

export default reducer;
